import React from "react"

const TwitterLogo = () => {
  return (
    <except-outlook>
      <div
        style={{
          display: "inline-block",
          float: "right",
          paddingBottom: "0px"
        }}
      >
        <img
          width="26"
          height="26"
          style={{ width: "26px", height: "26px" }}
          alt="Twitter Logo"
          src={`${process.env.NODE_FUNCTIONS_HOST}/icons?icon=twitter&foreground=1d8ced&background=000000&shape=icon-only&v=1`}
        />
      </div>
    </except-outlook>
  )
}

export default TwitterLogo
